import {Component, OnInit} from '@angular/core';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {CommonValidators} from '../../shared/common-components/common-validators';
import {ActivatedRoute, Router} from '@angular/router';
import {DataService} from '../../services/data.service';
import {UserProfileService} from 'src/app/services/user-profile/user-profile.service';
import {StateCountry} from 'src/app/shared/common-components/common-structure';
import AppConstants from '../../shared/common-components/AppConstants';
import {UserService} from '../../services/user/user.service';
import {ShipmentAuditTrailService} from '../../services/shipment-audit-trail/shipment-audit-trail.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { TspAgyProfileAuditTrailComponent } from '../tspagy-profile-audit-trail/tspagy-profile-audit-trail.component';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.css'],
    standalone: false
})
export class UserProfileComponent implements OnInit {
  userProfileForm: FormGroup;
  saveSuccessful = false;
  disabled = true;
  user: any = null;
  stateCountryType: any;
  state: any;
  country: any;
  stateList: StateCountry[] = null;
  countryList: StateCountry[] = null;
  disableCityState: boolean;
  showAuthOfficial: boolean;
  zipValue: any;
  uspsData: any;
  invalidZip: boolean;
  gsaEmail: boolean;
  isAgencyuser: boolean;
  isShowUserList: boolean;
  isCarrierAdmin: boolean;
  isAgencyAdmin: boolean;
  isAgencyAuditor: boolean;
  isSystemAdmin : boolean;
  pocFName: any;
  pocLName: any;
  pocPhone: any;
  pocEmail: any;
  bsModalRef: BsModalRef;
  roleName: string;

  constructor(private userProfileService: UserProfileService,
              private fb: FormBuilder,
              private alertService: AlertService,
              private dataService: DataService,
              private route: ActivatedRoute,
              private tmssLoader: LoadingService,
              private router: Router,
              private userService: UserService,
              private shipmentAuditTrailService: ShipmentAuditTrailService,
              private modalService: BsModalService) {
    this.userProfileForm = this.fb.group({
      firstName: new FormControl('', Validators.required),
      lastName: [null, [Validators.required]],
      middleInitial: [null],
      title: [null, [Validators.required]],
      address: [null, [Validators.required]],
      address2: [null],
      city: [null, [Validators.required]],
      state: new FormControl('', [Validators.required]),
      zip: new FormControl('', [Validators.required, CommonValidators.numeric, CommonValidators.lengthFive, CommonValidators.allZeros]),
      zone: [null],
      country: new FormControl('', [Validators.required]),
      mobilePhone: new FormControl(''),
      phone: new FormControl('', [Validators.required, Validators.minLength(10), this.numericsOnly]),
      phoneExt: [null],
      email: new FormControl('', [Validators.required, CommonValidators.email])
    });
  }

  numericsOnly(c: FormControl) {
    const phone = /^[0-9]*$/;
    return phone.test(c.value) ? null : {
      numericsOnly: {
        valid: false
      }
    };
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['userId'] && params['organizationId']) {
        this.loadUserData(params);
      } else {
        this.disabled = false;
      }
    });
    this.userProfileForm.valueChanges.subscribe(formData => {
      this.saveSuccessful = false;
    });
  }

  // load an existing user profile data
  loadUserData(params) {
    this.tmssLoader.show();
    this.showAuthOfficial = false;
    this.isAgencyuser = true;
    this.isCarrierAdmin = false;
    this.isAgencyAdmin = false;
    this.isAgencyAuditor = false;
    this.isSystemAdmin = false;
    const userId = params['userId'];
    const organizationId = params['organizationId'];
    this.userProfileService.getUserByOrganizationId(userId, organizationId).subscribe(user => {
      this.user = user;
      if (this.user.organizationEntity.agencyCustomerEntity == null) {
        this.isAgencyuser = false;
      }
      if (this.user.userEntity.roles != null && this.user.userEntity.roles[0].id == 5) {
        this.isCarrierAdmin = true;
      }
      if (this.user.userEntity.roles != null && this.user.userEntity.roles[0].id == 2) {
        this.isAgencyAdmin = true;
      }
      if (this.user.userEntity.roles != null && this.user.userEntity.roles[0].id == 1) {
        this.isAgencyAuditor = true;
      }
      if (this.user.userEntity.roles != null && this.user.userEntity.roles[0].id == 7) {
        this.isSystemAdmin = true;
      }
      this.tmssLoader.hide();
    }, (error) => {
      this.tmssLoader.hide();
      this.alertService.error('There was an error retrieving User Info');
    }, () => {
      this.verifyEmail();
      this.getStateList();
      this.getCountryList();
      this.userProfileForm.get('firstName').setValue(this.user.userEntity.firstName);
      this.userProfileForm.get('lastName').setValue(this.user.userEntity.lastName);
      this.userProfileForm.get('middleInitial').setValue(this.user.userEntity.middleInitial);
      this.userProfileForm.get('phone').setValue(this.user.userEntity.phone);
      this.userProfileForm.get('phoneExt').setValue(this.user.userEntity.phoneExtension);
      this.userProfileForm.get('email').setValue(this.user.userEntity.email);
      this.userProfileForm.get('mobilePhone').setValue(this.user.userEntity.mobilePhone);
      this.pocFName = this.user.organizationEntity.firstName;
      this.pocLName = this.user.organizationEntity.lastName;
      this.pocPhone = this.user.organizationEntity.phone;
      this.pocEmail = this.user.organizationEntity.email;
      const orgEmail = this.user.organizationEntity.email.toUpperCase();
      const userEmail = this.user.userEntity.email.toUpperCase();
      if (orgEmail === userEmail) {
        this.showAuthOfficial = true;
        this.userProfileForm.get('title').setValue(this.user.organizationEntity.title);
        this.userProfileForm.get('address').setValue(this.user.organizationEntity.addressLine1);
        this.userProfileForm.get('address2').setValue(this.user.organizationEntity.addressLine2);
        this.userProfileForm.get('city').setValue(this.user.organizationEntity.city);
        this.userProfileForm.get('state').setValue(this.user.organizationEntity.stateId);
        this.userProfileForm.get('zip').setValue(this.user.organizationEntity.zip);
        this.userProfileForm.get('zone').setValue(this.user.organizationEntity.zone);
        this.userProfileForm.get('country').setValue(this.user.organizationEntity.countryId);
      }
      this.roleName = this.showAuthOfficial ? 'Authorized Official' : this.user.userEntity.roles[0].name;
      // To Check if the user roles qualify to list Users (User List)
      if (this.user.userEntity.roles != null && (
        this.user.userEntity.roles[0].id === 3 || this.user.userEntity.roles[0].id === 4 ||
        this.user.userEntity.roles[0].id === 6)) {
        this.isShowUserList = false;
      } else {
        this.isShowUserList = true;
      }
    });
  }

  // update user profile data
  updateProfile() {
    this.tmssLoader.show();
    const userProfileForm = this.userProfileForm;
    this.user.userEntity.firstName = userProfileForm.value.firstName;
    this.user.userEntity.lastName = userProfileForm.value.lastName;
    this.user.userEntity.middleInitial = userProfileForm.value.middleInitial;
    this.user.userEntity.phone = userProfileForm.value.phone;
    this.user.userEntity.phoneExtension = userProfileForm.value.phoneExt;
    this.user.userEntity.mobilePhone = userProfileForm.value.mobilePhone;
    this.user.userEntity.email = userProfileForm.value.email;
    if (this.showAuthOfficial) {
      this.user.organizationEntity.firstName = userProfileForm.value.firstName;
      this.user.organizationEntity.lastName = userProfileForm.value.lastName;
      this.user.organizationEntity.middleInitial = userProfileForm.value.middleInitial;
      this.user.organizationEntity.phone = userProfileForm.value.phone;
      this.user.organizationEntity.phoneExtension = userProfileForm.value.phoneExt;
      this.user.organizationEntity.mobilePhone = userProfileForm.value.mobilePhone;
      this.user.organizationEntity.email = userProfileForm.value.email;
      this.user.organizationEntity.title = userProfileForm.value.title;
      this.user.organizationEntity.addressLine1 = userProfileForm.value.address;
      this.user.organizationEntity.addressLine2 = userProfileForm.value.address2;
      this.user.organizationEntity.city = userProfileForm.value.city;
      this.user.organizationEntity.stateId = userProfileForm.value.state;
      this.user.organizationEntity.zip = userProfileForm.value.zip;
      this.user.organizationEntity.countryId = userProfileForm.value.country;
    }
    this.userProfileService.updateProfile(this.user).subscribe(organization => {
        if (AppConstants.isNotNullCondition(organization)) {
          console.log(this.user);
          this.alertService.success('Successfully Updated the profile');
          window.scrollTo(0, 0);
          this.saveSuccessful = true;
          console.log(userProfileForm.value);
          this.tmssLoader.hide();
          this.userService.getUserDetails().subscribe(user => {
            if (AppConstants.isNotNullCondition(user)) {
              // on we found the user in the database setting user details in the behavioural subject
              this.userService.setUserObservable(user);
              localStorage.setItem('currentUser', JSON.stringify(user));
            }
          });
        }
      },
      error => {
        this.alertService.error('Error in saving profile' + error);
        this.tmssLoader.hide();
        console.log(error);
      });

  }

  // reset MFA for the user
  resetMfa() {
    this.userService.resetMfa(this.user.userEntity.email).subscribe(res => {
      this.alertService.success('An email has been sent to your email for resetting MFA.');
    }, err => {
      this.alertService.error('There was an error resetting your MFA. Please contact system administrator.');
    });
  }

// get states list
  getStateList() {
    this.tmssLoader.show();
    this.stateCountryType = 'State';
    this.userProfileService.getAllStates(this.stateCountryType).subscribe(
      states => {
        this.stateList = states;
        console.log(states);
        this.tmssLoader.hide();
        return this.stateList;
      }, (error) => {
        this.alertService.error('Error occurredn while getting the state list. Please contact system administrator.');
        this.tmssLoader.hide();
      });
  }

// to change states from the list
  changeState($event) {
    this.state = this.userProfileForm.get('state').value;
    console.log(this.state);
    return this.state;

  }

// to get the countrylist
  getCountryList() {
    this.tmssLoader.show();
    const countryList = [];
    this.stateCountryType = 'Country';
    this.userProfileService.getAllStates(this.stateCountryType).subscribe(
      countries => {
        this.countryList = countries;
        this.tmssLoader.hide();
        return this.countryList;
      }, (error) => {
        this.alertService.error('Error while gettign countries list.');
        this.tmssLoader.hide();
      });

  }

  /*
  * Zipcode search populates city and state
  */
  getCityState($event) {
    this.tmssLoader.show();
    console.log('In getting City and State');
    console.log(this.userProfileForm.controls['zip'].value);
    this.zipValue = this.userProfileForm.controls['zip'].value;
    if (this.zipValue !== '') {
      this.uspsData = this.userProfileService.getCityState(this.userProfileForm.controls['zip'].value)
        .subscribe(uspsDetails => {
            this.uspsData = uspsDetails;
            console.log(this.uspsData);
            this.userProfileForm.controls['city'].setValue(this.uspsData.cityName);
            this.userProfileForm.controls['state'].setValue(this.uspsData.stateId);
            this.userProfileForm.controls['country'].setValue('326');
            if (this.uspsData.zipCode == null) {
              this.invalidZip = true;
            } else {
              this.invalidZip = false;
            }
            this.tmssLoader.hide();
          }
        );
      return this.uspsData;
    }
  }

// to change the country from the list
  changeCountry($event) {
    console.log('In change Country', $event);
    this.country = this.userProfileForm.get('country').value;
    console.log(this.country);
    if (this.country !== '326') {
      this.stateList = null;
      this.disableCityState = true;
      this.userProfileForm.get('city').setValue(null);
      this.userProfileForm.controls['city'].setErrors(null);
      this.userProfileForm.get('state').setValue(null);
      this.userProfileForm.controls['state'].setErrors(null);
      this.userProfileForm.get('zip').setValue(null);
    } else {
      this.disableCityState = false;
      this.tmssLoader.show();
      this.stateCountryType = 'State';
      this.userProfileService.getAllStates(this.stateCountryType).subscribe(
        states => {
          this.stateList = states;
          this.tmssLoader.hide();
          return this.stateList;
        }, (error) => {
          this.alertService.error('Error while getting countries.');
          this.tmssLoader.hide();
        });
    }
    return this.country;
  }

  verifyEmail() {
    const email = this.user.userEntity.email;
    const splitted = email.split('@');
    const length = (splitted.length);
    const domain = splitted[length - 1];
    if (domain === 'gsa.gov' || domain === 'GSA.GOV') {
      this.gsaEmail = true;
    } else {
      this.gsaEmail = false;
    }
  }

  /**
   * @description navigates to user profile
   */
  goToUserList() {
    this.router.navigate(['/', 'agencyuser'], {
      queryParams: {
        organizationId: this.user.organizationId,
        isAgencyUser: this.isAgencyuser,
        isSystemAdmin: this.isSystemAdmin,
        isAuditor: this.user.userEntity.roles[0].id === 1,
        isFromUserProfile: true,
        userIdFromUserProfile: this.user.userId
      }
    });
  }

  /**
   * @description navigates to user profile
   */
  goToAccount() {
    this.router.navigate(['/', 'accountinfo'], {
      queryParams: {
        userId: this.user.userId
      }
    });
  }

  /**
   * @description programatical navigation to go to carrier contact info screen.
   */
  gotoCarrierContactInfo() {
    this.router.navigate(['/carriercontact'],
      {
        queryParams: {
          organizationId: [this.user.organizationId],
          carrierId: [this.user.organizationEntity.carrierEntity.carrierId],
          businessType: [this.user.organizationEntity.carrierEntity.businessType],
          scac: [this.user.organizationEntity.carrierEntity.scac]
        }
      });
  }

  /**
   * @description programatical navigation to go to carrier contact info screen.
   */
  gotoNotificationsPrefs() {
    if (this.isCarrierAdmin) {
      this.router.navigate(['/notificationspreferences'],
        {
          queryParams: {
            organizationId: [this.user.organizationId],
            userId: [this.user.userId],
            carrierId: [this.user.organizationEntity.carrierEntity.carrierId],
            businessType: [this.user.organizationEntity.carrierEntity.businessType],
            scac: [this.user.organizationEntity.carrierEntity.scac],
            name: [this.user.organizationEntity.carrierEntity.scacName],
            permissions: [this.user.organizationEntity.permission],
            role: ['carrierAdmin'],
            comingFrom: ['userProfileTsp']
          }
        });
    }
    if (this.isAgencyAdmin) {
      console.log(this.user);
      this.router.navigate(['/notificationspreferences'],
        {
          queryParams: {
            organizationId: [this.user.organizationId],
            userId: [this.user.userId],
            name: [this.user.organizationEntity.agencyCustomerEntity.agencyMasterEntity.agencyBureauName],
            role: ['agencyAdmin'],
            permissions: [this.user.organizationEntity.permission],
            comingFrom: ['userProfileAgency']

          }
        });
    }
    if (this.isAgencyAuditor) {
      console.log(this.user);
      this.router.navigate(['/notificationspreferences'],
        {
          queryParams: {
            organizationId: [this.user.organizationId],
            userId: [this.user.userId],
            name: [this.user.organizationEntity.agencyCustomerEntity.agencyMasterEntity.agencyBureauName],
            role: ['agencyAuditor'],
            permissions: [this.user.organizationEntity.permission],
            comingFrom: ['userProfileAgency']

          }
        });
    }
  }
  auditTrailLogList: any;
  onViewAuditTrail(){
    let updateProgram = (this.showAuthOfficial)? "UserProfileAndAuth" : "UserProfile";
    let orgId = this.user?.organizationId;
    this.tmssLoader.show();
    this.shipmentAuditTrailService.getAuditTrailListByUpdateProgramAndOrganizationIdAndUpdateId(updateProgram, orgId) .subscribe(
      (data:any) => {
        if(data){
          this.auditTrailLogList = data.sort((objA: any, objB: any) =>{
            return Number(new Date(objB.updateDate)) - Number(new Date(objA.updateDate));
          } );
          this.tmssLoader.hide();
          let repStr = updateProgram+".";
          this.auditTrailLogList.forEach((e:any) => {
            console.log(e.fieldName.replace(/repStr/gi,""));
            return e.fieldName.replace(/repStr/gi,"");
          });
          console.log(this.auditTrailLogList);
          const initialState: any = {
            auditTrailLogList: this.auditTrailLogList,
            profile: updateProgram
          };
          this.bsModalRef = this.modalService.show(TspAgyProfileAuditTrailComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
        }
      },(error:any)=> {
        console.log('There was an error retrieving auditTrailLog records');
        this.tmssLoader.hide();
        this.alertService.error('There was an error retrieving auditTrailLog records');
      }
    )
  }

}
